<template>
  <div>
    <div class="header">
      <es-header>
        <template #header>
          <div>
            Match History
          </div>
        </template>
        <template #actions>
          <ul>
            <li class="p-narrow no-border">
              <div class="list-content">
                <a
                  role="button"
                  tabindex="0"
                  :class="{ disabled: loading }"
                  @click="$root.$emit('refreshMatchHistory')"
                  @keypress="$root.$emit('refreshMatchHistory')"
                >
                  <font-awesome-icon
                    size="lg"
                    title="Click to refresh data."
                    :icon="['fas', 'sync-alt']"
                  />
                </a>
              </div>
            </li>
          </ul>
        </template>
      </es-header>
    </div>
    <div class="tabs-container no-border-top">
      <es-tabs :tabs="tabs" ref="tabs"></es-tabs>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSyncAlt,
} from '@fortawesome/pro-solid-svg-icons';
import EsHeader from '@/components/EsHeader.vue';
import EsTabs from '../../../components/EsTabs.vue';

library.add(
  faSyncAlt,
);

export default {
  components: {
    EsHeader,
    EsTabs,
  },
  mounted() {
    this.$root.$on('matchHistoryLoading', this.setLoading);
  },
  destroyed() {
    this.$root.$off('matchHistoryLoading');
  },
  data() {
    return {
      loading: false,
      tabs: [],
    };
  },
  methods: {
    setLoading(val) {
      this.loading = val;
    },
  },
  created() {
    this.tabs = [
      {
        path: 'batches',
        label: 'BATCHES',
      },
      {
        path: 'transactions',
        label: 'TRANSACTIONS',
      },
      {
        path: 'rejected',
        label: 'REJECTED',
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
  a.disabled
    color: #999
    cursor:  default
    text-decoration:  none
    pointer-events: none
    &:hover
      text-decoration:  none
</style>
